import React, { Component } from 'react';
import { isAndroid, isIOS } from "react-device-detect";
import logo from './../../../../assets/img/logo1.png';
import googleStore from './../../../../assets/img/Mealmanage/google-play.png';
import iosStore from './../../../../assets/img/Mealmanage/apple-store.png';
import {parentAndroidPayStoreUrl, parentIosPayStoreUrl} from './../../../../server/constants'

class DeviceInfo extends Component {
    constructor(props){
        super(props);
        this.state={
            showAlert:true
        }
    }
    closeAlert=()=>{
        this.setState({showAlert:false});
    }
    render() {
        const{showAlert}=this.state;
        return (
            <div className='row'>
                <div className='col-md-12'>
                { showAlert?
                   ( isAndroid ? (
                        <div className="alert alert-info shadow" role="alert">
                            <div className='row'>
                                <div className='col-sm-12'>
                                <button type="button"  aria-label="Close" style={{ 
                                    float: 'right', 
                                    border: 0,
                                    background: 0,
                                    fontSize: '30px',
                                    cursor: 'pointer'
                                    }}  onClick={()=>{
                                        this.closeAlert()
                                    }}>
                                <span aria-hidden="True" style={{color:"#856404", fontSize: '30px'}} >&times;</span>
                            </button>
                                </div>
                            </div>                            
                            <div className="row">
                                <div className='col-sm-2 text-center'> <img src={logo} height={'45px'} /></div>
                                <div className='col-sm-7  text-center'>                            
                                        <p style={{  fontSize: "20px", color: '#ea7066', paddingTop:'10px'}}>Click here to download MealManage Parent Mobile App</p>                            
                                </div>                             
                                <div className='col-sm-2  text-center'>
                                    <a href={parentAndroidPayStoreUrl}>
                                        <img src={googleStore} height={'45px'} />
                                    </a>
                                </div>                    
                            </div>
                        </div>) : isIOS ? (
                            <div className="alert alert-info shadow" role="alert">
                                <div className='col-sm-12 text-right'>
                                    <button type="button"  aria-label="Close" style={{                                       
                                        border: 0,
                                        background: 0,
                                        fontSize: '30px',
                                        cursor: 'pointer'
                                        }}  onClick={()=>{
                                            this.closeAlert()
                                        }}>
                                        <span aria-hidden="True" style={{color:"#856404", fontSize: '30px'}} >&times;</span>
                                    </button>
                                </div>
                            <div className="row">
                                <div className='col-sm-2 text-center'> <img src={logo} height={'45px'} /></div>
                                <div className='col-sm-7  text-center'>                            
                                        <p style={{  fontSize: "20px", color: '#ea7066', paddingTop:'10px'}}>
                                        Click here to download MealManage Parent Mobile App</p>                            
                                </div>                             
                                <div className='col-sm-2  text-center'>
                                    <a href={parentIosPayStoreUrl}>
                                        <img src={iosStore} height={'45px'} />
                                    </a>
                                </div>                    
                            </div>
                        </div>                                                   
                    ):null ):null
                }
                </div>                
            </div>
        );
    }
}

export default DeviceInfo;


// WEBPACK FOOTER //
// ./src/components/Parent/Home/deviceInfo/index.js